/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.MultipointsElevationRequest = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The MultipointsElevationRequest model module.
   * @module model/MultipointsElevationRequest
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>MultipointsElevationRequest</code>.
   * An elevation request object for points.
   * @alias module:model/MultipointsElevationRequest
   * @class
   * @param wellKnownText {String} Required. The Well Known Text (WKT) of the feature to get the elevation from.
   */
  var exports = function(wellKnownText) {
    var _this = this;

    _this['wellKnownText'] = wellKnownText;


  };

  /**
   * Constructs a <code>MultipointsElevationRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MultipointsElevationRequest} obj Optional instance to populate.
   * @return {module:model/MultipointsElevationRequest} The populated <code>MultipointsElevationRequest</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('wellKnownText')) {
        obj['wellKnownText'] = ApiClient.convertToType(data['wellKnownText'], 'String');
      }
      if (data.hasOwnProperty('srid')) {
        obj['srid'] = ApiClient.convertToType(data['srid'], 'Number');
      }
      if (data.hasOwnProperty('elevationUnit')) {
        obj['elevationUnit'] = ApiClient.convertToType(data['elevationUnit'], 'String');
      }
    }
    return obj;
  }

  /**
   * Required. The Well Known Text (WKT) of the feature to get the elevation from.
   * @member {String} wellKnownText
   */
  exports.prototype['wellKnownText'] = undefined;
  /**
   * The SRID (coordinate system) of the WellKnownText.
   * @member {Number} srid
   */
  exports.prototype['srid'] = undefined;
  /**
   * The unit of measure in which the elevation should be expressed.
   * @member {module:model/MultipointsElevationRequest.ElevationUnitEnum} elevationUnit
   */
  exports.prototype['elevationUnit'] = undefined;


  /**
   * Allowed values for the <code>elevationUnit</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ElevationUnitEnum = {
    /**
     * value: "Meter"
     * @const
     */
    "Meter": "Meter",
    /**
     * value: "Feet"
     * @const
     */
    "Feet": "Feet",
    /**
     * value: "Kilometer"
     * @const
     */
    "Kilometer": "Kilometer",
    /**
     * value: "Mile"
     * @const
     */
    "Mile": "Mile",
    /**
     * value: "UsSurveyFeet"
     * @const
     */
    "UsSurveyFeet": "UsSurveyFeet",
    /**
     * value: "Yard"
     * @const
     */
    "Yard": "Yard",
    /**
     * value: "NauticalMile"
     * @const
     */
    "NauticalMile": "NauticalMile",
    /**
     * value: "Inch"
     * @const
     */
    "Inch": "Inch",
    /**
     * value: "Link"
     * @const
     */
    "Link": "Link",
    /**
     * value: "Chain"
     * @const
     */
    "Chain": "Chain",
    /**
     * value: "Pole"
     * @const
     */
    "Pole": "Pole",
    /**
     * value: "Rod"
     * @const
     */
    "Rod": "Rod",
    /**
     * value: "Furlong"
     * @const
     */
    "Furlong": "Furlong",
    /**
     * value: "Vara"
     * @const
     */
    "Vara": "Vara",
    /**
     * value: "Arpent"
     * @const
     */
    "Arpent": "Arpent"  };


  return exports;
}));



